import { InfoCircle } from '@/assets/icons'
import { Popover, PopoverAnchor, PopoverContent, PopoverTrigger } from '@/components/popover/Popover'

import { getMatterRoleDescriptions } from './matter-member-copy'

/** "Roles & Permissions" info popover — shown to collaborators so they know what they (and others) can do. */
export function RolesPermissionsPopover({ editorEnabled = false, hasEditorAssignments = false }: { editorEnabled?: boolean; hasEditorAssignments?: boolean }) {
  return (
    <Popover>
      <PopoverTrigger asChild>
        <button
          type="button"
          className="flex shrink-0 items-center gap-1 rounded bg-brand-neutral-100 px-2 py-0.5 text-xs font-medium text-brand-neutral-600 outline-hidden hover:bg-brand-neutral-200 focus-visible:ring-2 focus-visible:ring-brand-500"
        >
          Roles & Permissions
          <PopoverAnchor asChild>
            <span className="inline-flex size-3.5">
              <InfoCircle className="size-3.5" aria-hidden />
            </span>
          </PopoverAnchor>
        </button>
      </PopoverTrigger>
      <PopoverContent
        width="auto"
        align="end"
        alignOffset={-8}
        arrowPadding={6}
        className="w-[265px] rounded-md p-0 shadow-none [filter:drop-shadow(0px_0.6px_12.5px_rgba(0,0,0,0.10))_drop-shadow(0px_10px_5px_rgba(0,0,0,0.04))]"
      >
        <div className="flex flex-col gap-0.5 px-5 py-4">
          {getMatterRoleDescriptions(editorEnabled, hasEditorAssignments).map((role) => (
            <div key={role.label} className="py-2">
              <p className="flex min-h-6 items-center text-sm font-medium leading-5 tracking-[-0.15px] text-brand-neutral-700">{role.label}</p>
              <p className="text-xs font-normal leading-4 text-brand-neutral-600">{role.description}</p>
            </div>
          ))}
        </div>
        {editorEnabled && (
          <div className="flex items-start gap-0.5 rounded-b border border-brand-neutral-200 bg-brand-neutral-100 py-2 pl-3 pr-5 text-xs font-normal leading-4 text-brand-neutral-600">
            <span className="shrink-0 text-brand-800">*</span>
            <span>Editor access to billing summaries, drafts, and tables coming soon.</span>
          </div>
        )}
      </PopoverContent>
    </Popover>
  )
}
